import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { withFirebase } from '../Firebase'
// eslint-disable-next-line no-unused-vars
import { AuthUserContext } from '../Session'

import * as ROUTES from '../../constants/routes'

import { useTranslation } from 'react-i18next'

const ChangeEmailPage = props => {
  const { t, i18n } = useTranslation()
  const baseUrl = i18n.language === 'sv' ? '' : '/' + i18n.language;

  const [email, setEmail] = useState('')
  const [error, setError] = useState(null)
  const navigate = useNavigate()

  const onSubmit = event => {
    // console.log(passwordOne);
    // navigate(baseUrl + ROUTES.ACCOUNT);
    props.firebase
      .doEmailUpdate(email)
      .then(() => {
        props.firebase.firedb
          .collection('users')
          .doc(props.firebase.auth.currentUser.uid)
          .update({ email });

        setEmail('')
        navigate(baseUrl + ROUTES.ACCOUNT)
        setError(null)
      })
      .catch(error => {
        setError(error)
      })

    event.preventDefault()
  }

  const onChange = event => {
    const { value } = event.target
    // console.log(name, value);
    setEmail(value)
  }

  const isInvalid = email === ''

  return (
    <div className='accountBox'>
      <div className='accountContent'>
        <h1 className='sectionTitle'>{t('change_email_page_heading')}</h1>
        <p>{t('change_email_page_desc')}</p>
        <form onSubmit={onSubmit}>
          <input
            name='email'
            value={email}
            onChange={onChange}
            type='email'
            placeholder={t('new_email_lbl')}
            className='inputStyle'
            style={{ marginLeft: 0 }}
            autoComplete='new-email'
          />
          <button disabled={isInvalid} type='submit' className='buttonStyle'>
            {t('save_btn')}
          </button>

          {error && (
            <p className='errorMessage' style={{ marginLeft: 0 }}>
              {t(error.message)}
            </p>
          )}
        </form>
      </div>
    </div>
  )
}

export default withFirebase(ChangeEmailPage)
